import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
	GET_SUBMISSION_DETAILS_RESET,
	UPDATE_SUBMISSION_DETAILS_RESET,
} from '../../redux/types'
import { useParams } from 'react-router-dom'
import {
	get_single_submission,
	update_single_submission,
} from '../../redux/actions/submissionActions'
import { IoPricetagsSharp } from 'react-icons/io5'
import Loader from '../../components/Loader'
import ModalComponent from '../../components/ModalComponent'
import { DateTime } from 'luxon'
import { comma } from '../../utils/helper'

const DashboardSingleSubmission = () => {
	const dispatch = useDispatch()

	const params = useParams()

	const [openModal, setOpenModal] = useState(false)
	const [status, setStatus] = useState('In Review')
	const [approvedAmount, setApprovedAmount] = useState('')

	const toggleModal = () => {
		setOpenModal(!openModal)
	}

	const getSubmissionDetail = useSelector((state) => state.getSubmissionDetail)
	const { loading, submissionDetail } = getSubmissionDetail

	const updateSubmissionDetail = useSelector(
		(state) => state.updateSubmissionDetail
	)
	const { loading: loadingUpdate, success } = updateSubmissionDetail

	const submitHandler = (e) => {
		e.preventDefault()
		let data = {
			status,
			approvedAmount,
			email: submissionDetail.email,
			subId: params.id,
		}

		if (window.confirm('Are you sure?')) {
			dispatch(update_single_submission(params.id, data))
		}

		setTimeout(() => {
			setOpenModal(false)
			setStatus(submissionDetail.status)
			setApprovedAmount('')
		}, 1000)
	}

	useEffect(() => {
		dispatch(get_single_submission(params.id))

		return () => {
			dispatch({ type: GET_SUBMISSION_DETAILS_RESET })
			dispatch({ type: UPDATE_SUBMISSION_DETAILS_RESET })
		}
	}, [dispatch, success])

	return (
		<section className='user_dashboard'>
			{loading ? (
				<Loader />
			) : submissionDetail ? (
				<>
					<div className='container'>
						<div className='row mb-3'>
							<div className='col-md-7'>
								<h1 className='page_header'> {submissionDetail.title} </h1>
								<p>{submissionDetail.subTitle && submissionDetail.subTitle}</p>

								<p>
									Date Submitted:{' '}
									{DateTime.fromISO(submissionDetail.createdAt).toLocaleString(
										DateTime.DATETIME_MED
									)}
								</p>
							</div>
							<div className='col-md-5 text-rightt'>
								<div className='d-flex justify-end'>
									<p className='mr-4'>
										<IoPricetagsSharp /> {submissionDetail.category}
									</p>
									<p>
										<span className='green_dot dot_dot'></span>{' '}
										{submissionDetail.status}
									</p>
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-4 col-sm-6'>
								<img
									src={submissionDetail.image}
									alt=''
									className='img-fluid mb-4'
								/>
								<h5 className='desc'>
									<strong>Bank Details</strong>
								</h5>
								<p>
									<strong>Bank Name:</strong> {submissionDetail.bank}
								</p>
								<p>
									<strong>Account Name:</strong> {submissionDetail.accountName}
								</p>
								<p>
									<strong>Account Number:</strong>
									{submissionDetail.accountNumber}
								</p>
								<h5 className='desc'>
									<strong>Other Details</strong>
								</h5>
								<p>
									<strong>Asking Amount:</strong> &#8358;
									{comma(submissionDetail.askingAmount)}
								</p>
								<p>
									<strong>Location:</strong> {submissionDetail.location}
								</p>
								{submissionDetail.rewards !== '' ? (
									<p>
										<strong>Rewards:</strong> {submissionDetail.rewards}
									</p>
								) : null}

								<p>
									<strong>Campaign: </strong>
									{submissionDetail.submissionRound &&
										submissionDetail.submissionRound.name}
								</p>
								{submissionDetail.approvedAmount && (
									<p>
										<strong>Approved Amount:</strong> &#8358;
										{comma(submissionDetail.approvedAmount)}
									</p>
								)}
							</div>

							<div className='col-md-8 col-sm-6'>
								<div className='d-flex'>
									<p className='mr-1'>Script: </p>
									<a
										target='_blank'
										rel='noreferrer'
										download
										href={`https://feemfundy.herokuapp.com${submissionDetail.scriptLink}`}
									>
										Click here to view
									</a>
								</div>
								{submissionDetail.video ? (
									<div className='d-flex'>
										<p className='mr-1'> Video: </p>
										<a
											target='_blank'
											rel='noreferrer'
											href={`${submissionDetail.video}`}
										>
											Click here to view video
										</a>
									</div>
								) : null}

								<h5 className='desc'>
									<strong>Description</strong>
								</h5>
								<p>{submissionDetail.description}</p>
							</div>
						</div>
						<div>
							<button
								onClick={(e) => {
									e.preventDefault()
									setOpenModal(true)
								}}
								className='btn btn-danger'
							>
								{' '}
								Take Action{' '}
							</button>
						</div>
					</div>

					<ModalComponent
						open={openModal}
						toggle={toggleModal}
						title='Update Submission'
					>
						<div className='login_form'>
							<form className='tagForm' onSubmit={submitHandler}>
								<label className='label'>Status</label>
								<select
									className='form-select mb-3'
									onChange={(e) => setStatus(e.target.value)}
								>
									<option value='In Review'>In Review</option>
									<option value='Approved'> Approved </option>
									<option value='Rejected'>Rejected</option>
									<option value='Funded'> Funded </option>
								</select>
								<label className='label'>Approved Amouunt</label>
								<input
									type='text'
									value={approvedAmount}
									className='form-control mb-3'
									onChange={(e) => setApprovedAmount(e.target.value)}
								/>

								<div className='text-center mt-4'>
									<button className='btn btn-secondary form-control'>
										{loadingUpdate ? (
											<i className='fas fa-spinner fa-spin'></i>
										) : (
											'Update'
										)}
									</button>
								</div>
							</form>
						</div>
					</ModalComponent>
				</>
			) : (
				<div className='container'>
					<p>Nothing found</p>
				</div>
			)}
		</section>
	)
}
export default DashboardSingleSubmission
